import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

export const formatPrice = (price) => {
    if (!price) return 'Contact for price';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(price);
};

export const truncateText = (text, maxLength = 100) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
};

export const getStatusColor = (status) => {
    switch (status) {
        case 'active':
            return 'bg-green-100 text-green-800';
        case 'on_hold':
            return 'bg-yellow-100 text-yellow-800';
        case 'expired':
            return 'bg-red-100 text-red-800';
        case 'deleted':
            return 'bg-gray-100 text-gray-800';
        default:
            return 'bg-gray-100 text-gray-800';
    }
};

export const getCategoryIcon = (categorySlug) => {
    const icons = {
        'hotel-furniture': 'Sofa',
        'hotel-jobs': 'Briefcase',
        'housekeeping-supplies': 'SprayCan',
        'guest-supplies': 'Package',
        'real-estate': 'Building2',
        'furniture-liquidation': 'Warehouse',
        'events-announcements': 'Calendar',
        'misc': 'MoreHorizontal'
    };
    return icons[categorySlug] || 'Folder';
};

export const isAuthenticated = () => {
    return !!localStorage.getItem('hmc_token');
};

export const getStoredAdvertiser = () => {
    const stored = localStorage.getItem('hmc_advertiser');
    return stored ? JSON.parse(stored) : null;
};

export const setAuthData = (token, advertiser) => {
    localStorage.setItem('hmc_token', token);
    localStorage.setItem('hmc_advertiser', JSON.stringify(advertiser));
};

export const clearAuthData = () => {
    localStorage.removeItem('hmc_token');
    localStorage.removeItem('hmc_advertiser');
};

export const getUserEmail = () => {
    return localStorage.getItem('hmc_user_email');
};

export const setUserEmail = (email) => {
    localStorage.setItem('hmc_user_email', email);
};
